
<div v-if="filter" class="lm-border pa-3">
    <v-row class="no-frame">
        <v-col class="no-frame v-flex">
            <v-checkbox
                label   = "aktiv"
                v-model = "filter.active"
                class   = "mt-0"
                :ripple = "false"
                @change = "onChange"
                hide-details
            />
        </v-col>
        <v-col class="no-frame v-flex">
            <v-checkbox
                label   = "inaktiv"
                v-model = "filter.inactive"
                class   = "mt-0"
                :ripple = "false"
                @change = "onChange"
                hide-details
            />
        </v-col>
    </v-row>
</div>
